var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"educationAsk"},[_c('div',{staticClass:"tjfx"},[_c('p',[_vm._v("学历要求")]),_c('div',{staticClass:"numberRadius"},[_c('span'),_c('span'),_c('span'),_c('span')]),_c('div',{staticStyle:{"width":"100%","height":"368px","top":"-18px"},attrs:{"id":"education"}})])])])
}]

export { render, staticRenderFns }